import { useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from '../../../../services/translation/hooks/useTranslation';

import CodeIcon from '@mui/icons-material/Code';
import { NavbarIconButtonWithLabel } from '../NavbarIconButtonWithLabel';
export const DevSandboxNavButton = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();

  const active = location.pathname === '/dev-sandbox';

  return (
    <NavbarIconButtonWithLabel
      label={t('Developer Sandbox')}
      active={active}
      onClick={() => {
        if (location.pathname !== '/dev-sandbox') {
          navigate('/dev-sandbox');
        }
      }}
    >
      <CodeIcon />
    </NavbarIconButtonWithLabel>
  );
};
